// Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
//
// This software is the property of WSO2 LLC. and its suppliers, if any.
// Dissemination of any information or reproduction of any material contained
// herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
// You may not alter or remove any copyright or other notice from copies of this content.

import * as React from "react";
import { useEffect } from "react";
import { useGetApi } from "../../../data/hooks/api";
import { RESOURCE_SERVER_URLS } from "../../../data/configs/spl-config";
import DefaultTable from "../../DefaultTable";
import * as Types from "../../../data/utils/types";

export default function ListProjectContacts({
  id,
}: {
  id: string;
}): JSX.Element {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const apiUrl =
  RESOURCE_SERVER_URLS[0] +
    `/projects/${id}/contacts?offset=${
      page * rowsPerPage
    }&limit=${rowsPerPage}`;
  const { data, loading, error, getApiData } = useGetApi<
    Types.Contact[]
  >({ url: apiUrl, headers: { accept: "application/json" } });

  const colNameArray = ["Name", "Email", "State"];
  const colAttributeArray = ["contactName", "email", "state"];

  useEffect(() => {
    getApiData(apiUrl);
  }, [rowsPerPage, page]);

  return (
    <DefaultTable
      data={data}
      loading={loading}
      error={error}
      page={page}
      setPage={setPage}
      rowsPerPage={rowsPerPage}
      setRowsPerPage={setRowsPerPage}
      colNameArray={colNameArray}
      colAttributeArray={colAttributeArray}
    />
  );
}
